module.exports = __webpack_public_path__ + "static/media/complete.b768a971.svg";